import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from 'AppContext';
import './AccessibilityWidget.css';

// SVG Icons
const Icons = {
  accessibility: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
    </svg>
  ),
  close: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z" />
    </svg>
  ),
  reset: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 4c2.1 0 4.1.8 5.6 2.3 3.1 3.1 3.1 8.2 0 11.3a7.78 7.78 0 0 1-6.7 2.3l.5-2c1.7.2 3.5-.4 4.8-1.7a6.1 6.1 0 0 0 0-8.5A6.07 6.07 0 0 0 12 6v4.6l-5-5 5-5V4M6.3 17.6C3.7 15 3.3 11 5.1 7.9l1.5 1.5c-1.1 2.2-.7 5 1.2 6.8.5.5 1.1.9 1.8 1.2l-.6 2a8 8 0 0 1-2.7-1.8Z" />
    </svg>
  ),
  info: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  ),
  fontSize: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z" />
    </svg>
  ),
  fontWeight: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M13.5 15.5H10v-3h3.5A1.5 1.5 0 0 1 15 14a1.5 1.5 0 0 1-1.5 1.5m-3.5-9h3A1.5 1.5 0 0 1 14.5 8 1.5 1.5 0 0 1 13 9.5h-3m5.6 1.29c.97-.68 1.65-1.79 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.1 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42Z" />
    </svg>
  ),
  lineHeight: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M21 22H3v-2h18v2m0-18H3V2h18v2m-11 9.7h4l-2-5.4-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z" />
    </svg>
  ),
  letterSpacing: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M22 3v18h-2V3h2M4 3v18H2V3h2m6 10.7h4l-2-5.4-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z" />
    </svg>
  ),
  dyslexia: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="m21.59 11.59-8.09 8.09L9.83 16l-1.41 1.41 5.08 5.09L23 13M6.43 11 8.5 5.5l2.07 5.5m1.88 5h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3Z" />
    </svg>
  ),
  highlightLinks: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-5.06-8.94a3.37 3.37 0 0 1 0 4.75L11.73 17A3.29 3.29 0 0 1 7 17a3.31 3.31 0 0 1 0-4.74l1.35-1.36-.01.6c-.01.5.07 1 .23 1.44l.05.15-.4.41a1.6 1.6 0 0 0 0 2.28c.61.62 1.67.62 2.28 0l2.2-2.19c.3-.31.48-.72.48-1.15 0-.44-.18-.83-.48-1.14a.87.87 0 0 1 0-1.24.91.91 0 0 1 1.24 0m4.06-.7c0 .9-.35 1.74-1 2.38l-1.34 1.36v-.6c.01-.5-.07-1-.23-1.44l-.05-.14.4-.42a1.6 1.6 0 0 0 0-2.28 1.64 1.64 0 0 0-2.28 0l-2.2 2.2c-.3.3-.48 71-.48 1.14 0 .44.18.83.48 1.14.17.16.26.38.26.62s-.09.46-.26.62a.86.86 0 0 1-.62.25.88.88 0 0 1-.62-.25 3.36 3.36 0 0 1 0-4.75L12.27 7A3.31 3.31 0 0 1 17 7c.65.62 1 1.46 1 2.36Z" />
    </svg>
  ),
  highlightTitles: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5 4v3h5.5v12h3V7H19V4H5Z" />
    </svg>
  ),
  monochrome: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="m19 19-7-8v8H5l7-8V5h7m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z" />
    </svg>
  ),
  lowSaturation: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M11 9h2v2h-2V9m-2 2h2v2H9v-2m4 0h2v2h-2v-2m2-2h2v2h-2V9M7 9h2v2H7V9m12-6H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M9 18H7v-2h2v2m4 0h-2v-2h2v2m4 0h-2v-2h2v2m2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6Z" />
    </svg>
  ),
  highSaturation: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 16a4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4 4 4 0 0 1-4 4m6.7-3.6a6.06 6.06 0 0 0-.86-.4 5.98 5.98 0 0 0 3.86-5.59 6 6 0 0 0-6.78.54A5.99 5.99 0 0 0 12 .81a6 6 0 0 0-2.92 6.14A6 6 0 0 0 2.3 6.4 5.95 5.95 0 0 0 6.16 12a6 6 0 0 0-3.86 5.58 6 6 0 0 0 6.78-.54A6 6 0 0 0 12 23.19a6 6 0 0 0 2.92-6.14 6 6 0 0 0 6.78.54 5.98 5.98 0 0 0-3-5.19Z" />
    </svg>
  ),
  highContrast: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 17.93a8 8 0 0 1 0-15.86v15.86zm2-15.86a8 8 0 0 1 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87a8 8 0 0 1-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93a8.4 8.4 0 0 1-.19 1z" />
    </svg>
  ),
  lightContrast: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6 6 6 0 0 1 6 6 6 6 0 0 1-6 6m8-2.69L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69Z" />
    </svg>
  ),
  darkContrast: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M18 12c0-4.5-1.92-8.74-6-10a10 10 0 0 0 0 20c4.08-1.26 6-5.5 6-10Z" />
    </svg>
  ),
  superFocus: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M20 12h-2v4H6V8h4V6H6q-3.3 0-5.65 2.35T2 8v8q0 3.3 2.35 5.65T6 20h8q3.3 0 5.65-2.35T20 16zm-4 4h4v-8h-8v8zm-4-4" />
    </svg>
  ),
  screenReader: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </svg>
  ),
  readingGuide: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 13H5v-2h14v2z" />
    </svg>
  ),
  readingMask: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h10v2H7zm0 4h10v2H7z" />
    </svg>
  ),
  bigCursor: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="m12 2 4.5 9h-9L12 2zm0 13c-4.41 0-8 3.59-8 8h16c0-4.41-3.59-8-8-8z" />
    </svg>
  ),
  pageStructure: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M4 14h6v-4H4v4zm0 5h6v-4H4v4zM4 9h6V5H4v4zm8 5h8v-4h-8v4zm0 5h8v-4h-8v4zm0-14v4h8V5h-8z" />
    </svg>
  ),
  stopAnimations: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
    </svg>
  ),
  hideImages: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86-3 3.87L9 13.14 6 17h12l-3.86-5.14z" />
    </svg>
  ),
  imageTooltips: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
    </svg>
  ),
  profileSeizure: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1-15h-2v6h2V7zm0 8h-2v2h2v-2z" />
    </svg>
  ),
  profileAdhd: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1-6h2v2h-2v-2zm0-8h2v6h-2V8z" />
    </svg>
  ),
  profileVision: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  ),
  profileCognitive: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 3c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L4.35 19.4c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l1.9-1.9C9.17 19.59 10.53 20 12 20c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 15c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm1-9h-2v2H9v2h2v2h2v-2h2v-2h-2V9z" />
    </svg>
  ),
  globe: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.53c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.4z" />
    </svg>
  )
};

// Map Sienna translation keys to our custom widget translation keys
const mapSiennaKeys = (siennaData) => {
  const get = (key, fallback) => siennaData[key] || fallback;
  return {
    settingsTitle: get("Accessibility Menu", "Accessibility Settings"),
    resetSettings: get("Reset settings", "Reset Settings"),
    closePanel: get("Close", "Close Panel"),
    profilesTitle: get("Accessibility Profiles", "Accessibility Profiles"),
    seizureSafe: get("Seizure Safe Profile", "Seizure Safe"),
    seizureSafeDesc: get("Stops animations and reduces color saturation.", "Stops animations & reduces saturation."),
    adhdFriendly: get("ADHD Friendly Profile", "ADHD Friendly"),
    adhdFriendlyDesc: get("Reduces distractions for better focus.", "Reduces distractions for better focus."),
    lowVision: get("Visually Impaired Profile", "Low Vision"),
    lowVisionDesc: get("Enhances contrast and readability for low vision.", "Enhances contrast and readability for low vision."),
    cognitiveRead: get("Cognitive & Learning Profile", "Cognitive & Read"),
    cognitiveReadDesc: get("Helpful tools for reading and comprehension.", "Helpful tools for reading and comprehension."),
    textTitle: get("Content Adjustments", "Text & Readability"),
    adjustFontSize: get("Adjust Font Size", "Adjust Font Size"),
    boldText: get("Font Weight", "Bold Text"),
    lineHeight: get("Line Height", "Line Height"),
    letterSpacing: get("Letter Spacing", "Letter Spacing"),
    dyslexiaFont: get("Dyslexia Font", "Dyslexia Font"),
    highlightLinks: get("Highlight Links", "Highlight Links"),
    highlightTitles: get("Highlight Title", "Highlight Titles"),
    colorTitle: get("Color Adjustments", "Color & Contrast"),
    monochrome: get("Monochrome", "Monochrome"),
    lowSaturation: get("Low Saturation", "Low Saturation"),
    highSaturation: get("High Saturation", "High Saturation"),
    highContrast: get("High Contrast", "High Contrast"),
    lightContrast: get("Light Contrast", "Light Contrast"),
    darkMode: get("Dark Contrast", "Dark Mode"),
    aidsTitle: get("Visual & Navigation Aids", "Visual & Navigation Aids"),
    focusHighlight: get("Super Focus", "Focus Highlight"),
    readingGuide: get("Reading Guide", "Reading Guide"),
    readingMask: get("Reading Mask", "Reading Mask"),
    bigCursor: get("Big Cursor", "Big Cursor"),
    screenReader: get("Screen Reader", "Screen Reader"),
    pageStructure: get("Page Structure", "Page Structure"),
    additionalTitle: get("Additional Tools", "Additional Controls"),
    pauseGifs: get("Stop Animations", "Pause Gifs"),
    hideImages: get("Hide Images", "Hide Images"),
    imageTooltips: get("Image Tooltips", "Image Tooltips"),
    // statement: get("Accessibility Statement", "Accessibility Statement"),
    // poweredBy: "Sienna Enabled",

    // Modal
    modalTitle: get("Page Structure", "Page Structure Helper"),
    headingsTab: get("Headings", "Headings"),
    landmarksTab: get("Landmarks", "Landmarks"),
    linksTab: get("Links", "Links"),
    focusAction: get("Focus element", "Focus"),
    noHeadings: "No headings found.",
    noLandmarks: "No landmarks/regions found.",
    noLinks: "No links found.",
    selectLang: get("Language", "Language")
  };
};

// Map option language values to exact Sienna CDN JSON filenames
const getLocaleFilename = (code) => {
  if (code === "zh") return "zh-Hans";
  if (code === "sr-cyr") return "sr-SP";
  return code;
};

// Multilingual translations dictionary (supporting WCAG & local standards)
const TRANSLATIONS = {
  en: {
    settingsTitle: "Accessibility Settings",
    resetSettings: "Reset Settings",
    closePanel: "Close Panel",
    profilesTitle: "Accessibility Profiles",
    seizureSafe: "Seizure Safe",
    seizureSafeDesc: "Stops animations & reduces saturation.",
    adhdFriendly: "ADHD Friendly",
    adhdFriendlyDesc: "Adds focus guide, hides images, pauses gifs.",
    lowVision: "Low Vision",
    lowVisionDesc: "High contrast, big cursor, scalable text.",
    cognitiveRead: "Cognitive & Read",
    cognitiveReadDesc: "Dyslexia font, bold titles, wider spacing.",
    textTitle: "Text & Readability",
    adjustFontSize: "Adjust Font Size",
    boldText: "Bold Text",
    lineHeight: "Line Height",
    letterSpacing: "Letter Spacing",
    dyslexiaFont: "Dyslexia Font",
    highlightLinks: "Highlight Links",
    highlightTitles: "Highlight Titles",
    colorTitle: "Color & Contrast",
    monochrome: "Monochrome",
    lowSaturation: "Low Saturation",
    highSaturation: "High Saturation",
    highContrast: "High Contrast",
    lightContrast: "Light Contrast",
    darkMode: "Dark Mode",
    aidsTitle: "Visual & Navigation Aids",
    focusHighlight: "Focus Highlight",
    readingGuide: "Reading Guide",
    readingMask: "Reading Mask",
    bigCursor: "Big Cursor",
    screenReader: "Screen Reader",
    pageStructure: "Page Structure",
    additionalTitle: "Additional Controls",
    pauseGifs: "Pause Gifs",
    hideImages: "Hide Images",
    imageTooltips: "Image Tooltips",
    // statement: "Accessibility Statement",
    // poweredBy: "Sienna Enabled",

    // Modal
    modalTitle: "Page Structure Helper",
    headingsTab: "Headings",
    landmarksTab: "Landmarks",
    linksTab: "Links",
    focusAction: "Focus",
    noHeadings: "No headings found on this page.",
    noLandmarks: "No landmarks/regions found.",
    noLinks: "No links found.",
    selectLang: "Language / भाषा / Idioma"
  },
  hi: {
    settingsTitle: "एक्सेसिबिलिटी सेटिंग्स",
    resetSettings: "सेटिंग्स रीसेट करें",
    closePanel: "पैनल बंद करें",
    profilesTitle: "एक्सेसिबिलिटी प्रोफाइल",
    seizureSafe: "दौरा सुरक्षित",
    seizureSafeDesc: "एनिमेशन रोकता है और संतृप्ति कम करता है।",
    adhdFriendly: "एडीएचडी अनुकूल",
    adhdFriendlyDesc: "फोकस गाइड जोड़ता है, चित्र छुपाता है, जिफ़ रोकता है।",
    lowVision: "कम दृष्टि",
    lowVisionDesc: "उच्च कंट्रास्ट, बड़ा कर्सर, स्केलेबल टेक्स्ट।",
    cognitiveRead: "संज्ञानात्मक और पढ़ना",
    cognitiveReadDesc: "डिस्लेक्सिया फ़ॉन्ट, बोल्ड शीर्षक, व्यापक रिक्ति।",
    textTitle: "टेक्स्ट और पठनीयता",
    adjustFontSize: "फ़ॉन्ट आकार समायोजित करें",
    boldText: "बोल्ड टेक्स्ट",
    lineHeight: "पंक्ति की ऊंचाई",
    letterSpacing: "अक्षर दूरी",
    dyslexiaFont: "डिस्लेक्सिया फ़ॉन्ट",
    highlightLinks: "लिंक्स हाइलाइट करें",
    highlightTitles: "शीर्षक हाइलाइट करें",
    colorTitle: "रंग और कंट्रास्ट",
    monochrome: "ब्लैक एंड वाइट",
    lowSaturation: "कम संतृप्ति",
    highSaturation: "उच्च संतृप्ति",
    highContrast: "उच्च कंट्रास्ट",
    lightContrast: "लाइट कंट्रास्ट",
    darkMode: "डार्क मोड",
    aidsTitle: "दृश्य और नेविगेशन सहायक उपकरण",
    focusHighlight: "फोकस हाइलाइट",
    readingGuide: "रीडिंग गाइड",
    readingMask: "रीडिंग मास्क",
    bigCursor: "बड़ा कर्सर",
    screenReader: "स्क्रीन रीडर",
    pageStructure: "पेज संरचना",
    additionalTitle: "अतिरिक्त नियंत्रण",
    pauseGifs: "जिफ़ रोकें",
    hideImages: "चित्र छुपाएं",
    imageTooltips: "चित्र टूलटिप्स",
    statement: "एक्सेसिबिलिटी वक्तव्य",
    poweredBy: "सिएना सक्रिय",

    // Modal
    modalTitle: "पेज संरचना सहायक",
    headingsTab: "शीर्षक",
    landmarksTab: "सीमाचिह्न",
    linksTab: "लिंक्स",
    focusAction: "फोकस करें",
    noHeadings: "इस पेज पर कोई शीर्षक नहीं मिला।",
    noLandmarks: "कोई सीमाचिह्न/क्षेत्र नहीं मिला।",
    noLinks: "कोई लिंक्स नहीं मिला।",
    selectLang: "भाषा चुनें"
  },
  gu: {
    settingsTitle: "એક્સેસિબિલિટી સેટિંગ્સ",
    resetSettings: "સેટિંગ્સ રીસેટ કરો",
    closePanel: "પેનલ બંધ કરો",
    profilesTitle: "એક્સેસિબિલિટી પ્રોફાઇલ્સ",
    seizureSafe: "વાઈ સુરક્ષિત",
    seizureSafeDesc: "એનિમેશન રોકે છે અને સેચ્યુરેશન ઘટાડે છે.",
    adhdFriendly: "ADHD અનુકૂળ",
    adhdFriendlyDesc: "ફોકસ ગાઈડ ઉમેરે છે, ચિત્રો છુપાવે છે, જીઆઇએફ રોકે છે.",
    lowVision: "ઓછી દ્રષ્ટિ",
    lowVisionDesc: "ઉચ્ચ કોન્ટ્રાસ્ટ, મોટું કર્સર, માપી શકાય તેવો લખાણ.",
    cognitiveRead: "જ્ઞાનાત્મક અને વાંચન",
    cognitiveReadDesc: "ડિસ્લેક્સીયા ફોન્ટ, બોલ્ડ ટાઇટલ, વિશાળ અંતર.",
    textTitle: "લખાણ અને વાંચનક્ષમતા",
    adjustFontSize: "ફોન્ટ સાઇઝ એડજસ્ટ કરો",
    boldText: "બોલ્ડ લખાણ",
    lineHeight: "લાઇનની ઊંચાઈ",
    letterSpacing: "અક્ષરો વચ્ચેની જગ્યા",
    dyslexiaFont: "ડિસ્લેક્સીયા ફોન્ટ",
    highlightLinks: "લિંક્સ હાઇલાઇટ કરો",
    highlightTitles: "શીર્ષકો હાઇલાઇટ કરો",
    colorTitle: "રંગ અને કોન્ટ્રાસ્ટ",
    monochrome: "મોનોક્રોમ",
    lowSaturation: "ઓછું સેચ્યુરેશન",
    highSaturation: "ઉચ્ચ સેચ્યુરેશન",
    highContrast: "ઉચ્ચ કોન્ટ્રાસ્ટ",
    lightContrast: "લાઇટ કોન્ટ્રાસ્ટ",
    darkMode: "ડાર્ક મોડ",
    aidsTitle: "દ્રશ્ય અને નેવિગેશન સહાયક",
    focusHighlight: "ફોકસ હાઇલાઇટ",
    readingGuide: "રીડિંગ ગાઇડ",
    readingMask: "રીડિંગ માસ્ક",
    bigCursor: "મોટું કર્સર",
    screenReader: "સ્ક્રીન રીડર",
    pageStructure: "પેજનું માળખું",
    additionalTitle: "વધારાના નિયંત્રણો",
    pauseGifs: "જીઆઇએફ રોકો",
    hideImages: "ચિત્રો છુપાવો",
    imageTooltips: "ચિત્ર ટૂલટિપ્સ",
    statement: "એક્સેસિબિલિટી સ્ટેટમેન્ટ",
    poweredBy: "Sienna સક્ષમ",

    // Modal
    modalTitle: "પેજ સ્ટ્રક્ચર હેલ્પર",
    headingsTab: "શીર્ષકો",
    landmarksTab: "લેન્ડમાર્ક્સ",
    linksTab: "લિંક્સ",
    focusAction: "ફોકસ કરો",
    noHeadings: "આ પેજ પર કોઈ શીર્ષકો મળ્યા નથી.",
    noLandmarks: "કોઈ લેન્ડમાર્ક્સ મળ્યા નથી.",
    noLinks: "કોઈ લિંક્સ મળી નથી.",
    selectLang: "ભાષા પસંદ કરો"
  },
  mr: {
    settingsTitle: "एक्सेसिबिलिटी सेटिंग्स",
    resetSettings: "सेटिंग्स रीसेट करा",
    closePanel: "पॅनेल बंद करा",
    profilesTitle: "एक्सेसिबिलिटी प्रोफाइल",
    seizureSafe: "दौरा सुरक्षित",
    seizureSafeDesc: "एनिमेशन थांबवते आणि संपृक्तता कमी करते.",
    adhdFriendly: "एडीएचडी अनुकूल",
    adhdFriendlyDesc: "फोकस मार्गदर्शक जोडते, प्रतिमा लपवते, गिफ थांबवते.",
    lowVision: "कमी दृष्टी",
    lowVisionDesc: "उच्च कॉन्ट्रास्ट, मोठा कर्सर, स्केलेबल मजकूर.",
    cognitiveRead: "ज्ञानात्मक आणि वाचन",
    cognitiveReadDesc: "डिस्लेक्सिया फॉन्ट, ठळक शीर्षके, विस्तृत अंतर.",
    textTitle: "मजकूर आणि वाचनक्षमता",
    adjustFontSize: "फॉन्ट आकार समायोजित करा",
    boldText: "ठळक मजकूर",
    lineHeight: "ओळ उंची",
    letterSpacing: "अक्षर अंतर",
    dyslexiaFont: "डिस्लेक्सिया फॉन्ट",
    highlightLinks: "लिंक्स हायलाइट करा",
    highlightTitles: "शीर्षके हायलाइट करा",
    colorTitle: "रंग आणि कॉन्ट्रास्ट",
    monochrome: "ब्लॅक अँड व्हाईट",
    lowSaturation: "कमी संपृक्तता",
    highSaturation: "उच्च संपृक्तता",
    highContrast: "उच्च कॉन्ट्रास्ट",
    lightContrast: "लाइट कॉन्ट्रास्ट",
    darkMode: "डार्क मोड",
    aidsTitle: "दृश्य आणि नेव्हिगेशन साधने",
    focusHighlight: "फोकस हायलाइट",
    readingGuide: "रीडिंग गाइड",
    readingMask: "रीडिंग मास्क",
    bigCursor: "मोठा कर्सर",
    screenReader: "स्क्रीन रीडर",
    pageStructure: "पेज रचना",
    additionalTitle: "अतिरिक्त नियंत्रणे",
    pauseGifs: "गिफ थांबवा",
    hideImages: "प्रतिमा लपवा",
    imageTooltips: "प्रतिमा टूलटिप्स",
    statement: "प्रवेशयोग्यता विधान",
    poweredBy: "सिएना सक्षम",
    modalTitle: "पेज रचना सहाय्यक",
    headingsTab: "शीर्षके",
    landmarksTab: "लँडमार्क",
    linksTab: "लिंक्स",
    focusAction: "फोकस करा",
    noHeadings: "या पृष्ठावर कोणतीही शीर्षके आढळली नाहीत.",
    noLandmarks: "कोणतीही लँडमार्क आढळली नाहीत.",
    noLinks: "कोणतीही लिंक्स आढळली नाहीत.",
    selectLang: "भाषा निवडा"
  },
  bn: {
    settingsTitle: "অ্যাক্সেসিবিলিটি সেটিংস",
    resetSettings: "সেটিংস পুনরায় সেট করুন",
    closePanel: "প্যানেল বন্ধ করুন",
    profilesTitle: "অ্যাক্সেসিবিলিটি প্রোফাইল",
    seizureSafe: "খিঁচুনি নিরাপদ",
    seizureSafeDesc: "অ্যানিমেশন বন্ধ করে এবং স্যাচুরেশন হ্রাস করে।",
    adhdFriendly: "এডিএইচডি বন্ধুত্বপূর্ণ",
    adhdFriendlyDesc: "ফোকাস গাইড যুক্ত করে, চিত্রগুলি গোপন করে, জিআইএফ বিরতি দেয়।",
    lowVision: "স্বল্প দৃষ্টি",
    lowVisionDesc: "উচ্চ বৈসাদৃশ্য, বড় কার্সার, স্কেলযোগ্য পাঠ্য।",
    cognitiveRead: "ज्ञानीय এবং পঠন",
    cognitiveReadDesc: "ডিসলেক্সিয়া ফন্ট, সাহসী শিরোনাম, প্রশস্ত ব্যবধান।",
    textTitle: "পাঠ্য ও পঠনযোগ্যতা",
    adjustFontSize: "ফন্টের আকার সামঞ্জস্য করুন",
    boldText: "বোল্ড টেক্সট",
    lineHeight: "লাইনের উচ্চতা",
    letterSpacing: "অক্ষরের ব্যবধান",
    dyslexiaFont: "ডিসলেক্সিয়া ফন্ট",
    highlightLinks: "লিঙ্ক হাইলাইট করুন",
    highlightTitles: "শিরোনাম হাইলাইট করুন",
    colorTitle: "রং ও বৈসাদৃশ্য",
    monochrome: "মনোক্রোম",
    lowSaturation: "কম স্যাচুরেশন",
    highSaturation: "উচ্চ স্যাচুরেশন",
    highContrast: "উচ্চ বৈসাদৃশ্য",
    lightContrast: "হালকা বৈসادৃশ্য",
    darkMode: "ডার্ক মোড",
    aidsTitle: "ভিজ্যুয়াল এবং নেভিগেশন এইডস",
    focusHighlight: "فोकस হাইলাইট",
    readingGuide: "পড়ার গাইড",
    readingMask: "পড়ার মাস্ক",
    bigCursor: "বড় কার্সার",
    screenReader: "স্ক্রিন রিডার",
    pageStructure: "পৃষ্ঠা গঠন",
    additionalTitle: "অতিরিক্ত নিয়ন্ত্রণ",
    pauseGifs: "জিআইএফ বিরতি দিন",
    hideImages: "চিত্র লুকান",
    imageTooltips: "চিত্রের বর্ণনা",
    statement: "অ্যাক্সেসযোগ্যতার বিবৃতি",
    poweredBy: "সিয়েনা সক্ষম",
    modalTitle: "পৃষ্ঠা কাঠামো সহায়ক",
    headingsTab: "শিরোনাম",
    landmarksTab: "ল্যান্ডমার্ক",
    linksTab: "লিঙ্ক",
    focusAction: "ফোকাস করুন",
    noHeadings: "এই পৃষ্ঠায় কোন শিরোনাম পাওয়া যায়নি।",
    noLandmarks: "কোন ল্যান্ডমার্ক পাওয়া যায়নি।",
    noLinks: "কোন লিঙ্ক পাওয়া যায়নি।",
    selectLang: "ভাষা নির্বাচন করুন"
  },
  kn: {
    settingsTitle: "ಪ್ರವೇಶಿಸುವಿಕೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    resetSettings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
    closePanel: "ಫಲಕವನ್ನು ಮುಚ್ಚಿ",
    profilesTitle: "ಪ್ರವೇಶಿಸುವಿಕೆ ಪ್ರೊಫೈಲ್ಗಳು",
    seizureSafe: "ಸೆಳವು ಸುರಕ್ಷಿತ",
    seizureSafeDesc: "ಅನಿಮೇಷನ್ ನಿಲ್ಲಿಸುತ್ತದೆ ಮತ್ತು ಸ್ಯಾಚುರೇಶನ್ ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
    adhdFriendly: "ಎಡಿಎಚ್ಡಿ ಸ್ನೇಹಿ",
    adhdFriendlyDesc: "ಫೋಕಸ್ ಮಾರ್ಗದರ್ಶಿ ಸೇರಿಸುತ್ತದೆ, ಚಿತ್ರಗಳನ್ನು ಮರೆಮಾಡುತ್ತದೆ, ಗಿಫ್ ವಿರಾಮಗೊಳಿಸುತ್ತದೆ.",
    lowVision: "ಕಡಿಮೆ ದೃಷ್ಟಿ",
    lowVisionDesc: "ಹೆಚ್ಚಿನ ಕಾಂಟ్రాಸ್ಟ್, ದೊಡ್ಡ ಕರ್ಸರ್, ಸ್ಕೇಲೆಬಲ್ ಪಠ್ಯ.",
    cognitiveRead: "ಅರಿವಿನ ಮತ್ತು ಓದುವಿಕೆ",
    cognitiveReadDesc: "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಫಾಂಟ್, ಬೋಲ್ಡ್ ಶೀರ್ಷಿಕೆಗಳು, ವಿಶಾಲ ಅಂತರ.",
    textTitle: "ಪಠ್ಯ ಮತ್ತು ಓದುವಿಕೆ",
    adjustFontSize: "ಫಾಂಟ್ ಗಾತ್ರ ಹೊಂದಿಸಿ",
    boldText: "ಬೋಲ್ಡ್ ಪಠ್ಯ",
    lineHeight: "ಸಾಲು ಎತ್ತರ",
    letterSpacing: "ಅક્ષರ ಅಂತರ",
    dyslexiaFont: "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಫಾಂಟ್",
    highlightLinks: "ಲಿಂಕ್ ಹೈಲೈట్ ಮಾಡಿ",
    highlightTitles: "ಶೀರ್ಷಿಕೆ ಹైಲైట్ ಮಾಡಿ",
    colorTitle: "ಬಣ್ಣ ಮತ್ತು ಕಾಂಟ్రాస్ట్",
    monochrome: "ಮೊನೊಕ್ರೋಮ್",
    lowSaturation: "ಕಡಿಮೆ ಸ್ಯಾಚುರೇಶನ್",
    highSaturation: "ಹೆಚ್ಚು ಸ్యాಚುರೇಶನ್",
    highContrast: "ಹೆಚ್ಚಿನ ಕಾಂಟ్రాస్ట్",
    lightContrast: "ಲೈట్ ಕಾಂట್ರಾస్ట్",
    darkMode: "ಡಾರ್క్ ಮೋడ్",
    aidsTitle: "ದೃಶ್ಯ ಮತ್ತು ನ್ಯಾವಿಗೇಷನ್ ನೆರవు",
    focusHighlight: "ಫೋಕస్ ಹೈಲೈట్",
    readingGuide: "ರೀಡಿಂಗ್ ಗೈಡ್",
    readingMask: "ರೀಡಿಂಗ್ ಮಾಸ್ಕ್",
    bigCursor: "ದೊಡ್ಡ ಕರ್ಸರ್",
    screenReader: "ಸ್ಕ್ರೀన్ ರೀಡర్",
    pageStructure: "ಪುಟ ರಚನೆ",
    additionalTitle: "ಹೆಚ್ಚುವರಿ ನಿಯಂತ್ರಣಗಳು",
    pauseGifs: "ಗಿಫ್ ವಿರಾಮಗೊಳಿಸಿ",
    hideImages: "ಚಿತ್ರ ಮರೆಮಾಡಿ",
    imageTooltips: "ಚಿತ್ರ ಟೂಲ್‌ಟಿಪ್ಸ್",
    statement: "ಪ್ರವೇಶಿಸುವಿಕೆ ಹೇಳಿಕೆ",
    poweredBy: "ಸಿಯೆನ್ನಾ ಸಕ್ರಿಯ",
    modalTitle: "ಪುಟ ರಚನೆ ಸಹಾಯಕ",
    headingsTab: "ಶೀರ್ಷಿಕೆಗಳು",
    landmarksTab: "ಲ್ಯಾಂಡ್‌ಮಾರ್ಕ್‌ಗಳು",
    linksTab: "ಲಿಂಕ್‌ಗಳು",
    focusAction: "ಫೋకస్ ಮಾಡಿ",
    noHeadings: "ಈ ಪುಟದಲ್ಲಿ ಯಾವುದೇ ಶೀರ್ಷಿಕೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    noLandmarks: "ಯಾವುದೇ ಲ್ಯಾಂಡ್‌ಮಾರ್ಕ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    noLinks: "ಯಾವುದೇ ಲಿಂಕ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    selectLang: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ"
  },
  ml: {
    settingsTitle: "ആക്സസിബിലിറ്റി ക്രമീകരണങ്ങൾ",
    resetSettings: "ക്രമീകരണങ്ങൾ പുനഃക്രമീകരിക്കുക",
    closePanel: "പാനൽ അടയ്ക്കുക",
    profilesTitle: "ആക്സസിബിലിറ്റി പ്രൊഫൈലുകൾ",
    seizureSafe: "ഫിറ്റ്സ് സുരക്ഷിതം",
    seizureSafeDesc: "ആനിമേഷനുകൾ നിർത്തുകയും സാച്ചുറേഷൻ കുറയ്ക്കുകയും ചെയ്യുന്നു.",
    adhdFriendly: "എഡിഎച്ച്ഡി അനുയോജ്യം",
    adhdFriendlyDesc: "ഫോക്കസ് ഗൈഡ് ചേർക്കുന്നു, ചിത്രങ്ങൾ മറയ്ക്കുന്നു, ഗിഫുകൾ താൽക്കാലികമായി നിർത്തുന്നു.",
    lowVision: "കുറഞ്ഞ കാഴ്ച",
    lowVisionDesc: "ഉയർന്ന കോൺട്രാസ്റ്റ്, വലിയ കർസർ, ക്രമീകരിക്കാവുന്ന വാചകം.",
    cognitiveRead: "കോഗ്നിറ്റീവ് & വായന",
    cognitiveReadDesc: "ഡിസ്ലെക്സിയ ഫോണ്ട്, ബോൾഡ് ശീർഷകങ്ങൾ, വിശാലമായ ഇടം.",
    textTitle: "വാചകവും വായനാക്ഷമതയും",
    adjustFontSize: "ഫോണ്ട് വലുപ്പം ക്രമീകരിക്കുക",
    boldText: "ബോൾഡ് ടെക്സ്റ്റ്",
    lineHeight: "വരിയുടെ ഉയരം",
    letterSpacing: "അക്ഷരങ്ങളുടെ ഇടം",
    dyslexiaFont: "ഡിസ്ലെക്സിയ ഫോണ്ട്",
    highlightLinks: "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
    highlightTitles: "ശീർഷകങ്ങൾ ഹൈലൈറ്റ് ചെയ്യുക",
    colorTitle: "നിറവും കോൺട്രസ്റ്റും",
    monochrome: "മോണോക്രോം",
    lowSaturation: "കുറഞ്ഞ സാച്ചുറേഷൻ",
    highSaturation: "ഉയർന്ന സാച്ചുറേഷൻ",
    highContrast: "ഉയർന്ന കോൺട്രാസ്റ്റ്",
    lightContrast: "ലൈറ്റ് കോൺട്രാസ്റ്റ്",
    darkMode: "ഡാർക്ക് മോഡ്",
    aidsTitle: "വിഷ്വൽ & നാവിഗേഷൻ സഹായികൾ",
    focusHighlight: "ഫോക്കസ് ഹൈലൈറ്റ്",
    readingGuide: "റീഡിംഗ് ഗൈഡ്",
    readingMask: "റീഡിംഗ് മാസ്ക്",
    bigCursor: "വജ്ര കർസർ",
    screenReader: "സ്ക്രീൻ റീഡർ",
    pageStructure: "പേജ് ഘടന",
    additionalTitle: "അധിക നിയന്ത്രണങ്ങൾ",
    pauseGifs: "ഗിഫുകൾ നിർത്തുക",
    hideImages: "ചിത്രങ്ങൾ മറയ്ക്കുക",
    imageTooltips: "ചിത്ര വിവരണങ്ങൾ",
    statement: "ആക്സസിബിലിറ്റി പ്രസ്താവന",
    poweredBy: "സീയെന്ന സജീവം",
    modalTitle: "പേജ് ഘടന സഹായി",
    headingsTab: "ശീർഷകങ്ങൾ",
    landmarksTab: "ലാൻഡ്മാർക്കുകൾ",
    linksTab: "ലിങ്കുകൾ",
    focusAction: "ഫോക്കస్ ചെയ്യുക",
    noHeadings: "ഈ പേജിൽ ശീർഷകങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    noLandmarks: "ലാൻഡ്മാർക്കുകളൊന്നും കണ്ടെത്തിയില്ല.",
    noLinks: "ലിങ്കുകളൊന്നും കണ്ടെത്തിയില്ല.",
    selectLang: "ഭാഷ തിരഞ്ഞെടുക്കുക"
  },
  ne: {
    settingsTitle: "पहुँचयोग्यता सेटिङहरू",
    resetSettings: "सेटिङहरू रिसेट गर्नुहोस्",
    closePanel: "प्यानल बन्द गर्नुहोस्",
    profilesTitle: "पहुँचयोग्यता प्रोफाइलहरू",
    seizureSafe: "अङ्कमाल सुरक्षित",
    seizureSafeDesc: "एनिमेसनहरू रोक्छ र संतृप्ति कम गर्छ।",
    adhdFriendly: "एडीएचडी अनुकूल",
    adhdFriendlyDesc: "फोकस गाइड थप्छ, छविहरू लुकाउँछ, जिफहरू रोक्छ।",
    lowVision: "कम दृष्टि",
    lowVisionDesc: "उच्च कन्ट्रास्ट, ठूलो कर्सर, मापनयोग्य पाठ।",
    cognitiveRead: "संज्ञानात्मक र पढाइ",
    cognitiveReadDesc: "डिस्लेक्सिया फन्ट, गाढा शीर्षक, व्यापक दूरी।",
    textTitle: "पाठ र पठनीयता",
    adjustFontSize: "फन्ट साइज मिलाउनुहोस्",
    boldText: "गाढा पाठ",
    lineHeight: "लाइन उचाइ",
    letterSpacing: "अक्षर दूरी",
    dyslexiaFont: "डिस्लेक्सिया फन्ट",
    highlightLinks: "लिङ्कहरू हाइलाइट गर्नुहोस्",
    highlightTitles: "शीर्षकहरू हाइलाइट गर्नुहोस्",
    colorTitle: "रङ र कन्ट्रास्ट",
    monochrome: "मोनोक्रोम",
    lowSaturation: "कम संतृप्ति",
    highSaturation: "उच्च संतृप्ति",
    highContrast: "उच्च कन्ट्रास्ट",
    lightContrast: "हल्का कन्ट्रास्ट",
    darkMode: "डार्क मोड",
    aidsTitle: "दृश्य र नेभिगेसन सहायकहरू",
    focusHighlight: "फोकस हाइलाइट",
    readingGuide: "रीडिङ गाइड",
    readingMask: "रीडिङ मास्क",
    bigCursor: "ठूलो कर्सर",
    screenReader: "स्क्रिन रिडर",
    pageStructure: "पृष्ठ संरचना",
    additionalTitle: "थप नियन्त्रणहरू",
    pauseGifs: "जिफहरू रोक्नुहोस्",
    hideImages: "छविहरू लुकाउनुहोस्",
    imageTooltips: "छवि टुलटिपहरू",
    statement: "पहुँचयोग्यता कथन",
    poweredBy: "सिएना सक्षम",
    modalTitle: "पृष्ठ संरचना सहायक",
    headingsTab: "शीर्षकहरू",
    landmarksTab: "ल्यान्डमार्कहरू",
    linksTab: "लिङ्कहरू",
    focusAction: "फोकस गर्नुहोस्",
    noHeadings: "यस पृष्ठमा कुनै शीर्षक फेला परेन।",
    noLandmarks: "कुनै ल्यान्डमार्क फेला परेन।",
    noLinks: "कुनै लिङ्क फेला परेन।",
    selectLang: "भाषा छान्नुहोस्"
  },
  pa: {
    settingsTitle: "ਪਹੁੰਚਯੋਗਤਾ ਸੈਟਿੰਗਾਂ",
    resetSettings: "ਸੈਟਿੰਗਾਂ ਰੀਸੈਟ ਕਰੋ",
    closePanel: "ਪੈਨਲ ਬੰਦ ਕਰੋ",
    profilesTitle: "ਪਹੁੰਚਯੋਗਤਾ ਪ੍ਰੋਫਾਈਲ",
    seizureSafe: "ਦੌਰੇ ਤੋਂ ਸੁਰੱਖਿਅਤ",
    seizureSafeDesc: "ਐਨੀਮੇਸ਼ਨਾਂ ਨੂੰ ਰੋਕਦਾ ਹੈ ਅਤੇ ਸੰਤ੍ਰਿਪਤਾ ਘਟਾਉਂਦਾ ਹੈ।",
    adhdFriendly: "ADHD ਅਨੁਕੂਲ",
    adhdFriendlyDesc: "ਫੋਕਸ ਗਾਈਡ ਜੋੜਦਾ ਹੈ, ਚਿੱਤਰਾਂ ਨੂੰ ਲੁਕਾਉਂਦਾ ਹੈ, ਜਿਫਾਂ ਨੂੰ ਰੋਕਦਾ ਹੈ।",
    lowVision: "ਘੱਟ ਦ੍ਰਿਸ਼ਟੀ",
    lowVisionDesc: "ਉੱਚ ਕੰਟਰਾਸਟ, ਵੱਡਾ ਕਰਸਰ, ਸਕੇਲੇਬਲ ਟੈਕਸਟ।",
    cognitiveRead: "ਗਿਆਨ ਸੰਬੰਧੀ ਅਤੇ ਪੜ੍ਹਨਾ",
    cognitiveReadDesc: "ਡਿਸਲੈਕਸੀਆ ਫੌਂਟ, ਬੋਲਡ ਸਿਰਲੇਖ, ਵਿਆਪਕ ਦੂਰੀ।",
    textTitle: "ਟੈਕਸਟ ਅਤੇ ਪੜ੍ਹਨਯੋਗਤਾ",
    adjustFontSize: "ਫੌਂਟ ਦਾ ਆਕਾਰ ਵਿਵਸਥਿਤ ਕਰੋ",
    boldText: "ਬੋਲਡ ਟੈਕਸٹ",
    lineHeight: "ਲਾਈਨ ਦੀ ਉਚਾਈ",
    letterSpacing: "ਅੱਖਰਾਂ ਦੀ ਦੂਰੀ",
    dyslexiaFont: "ਡਿਸਲੈਕਸੀਆ ਫੌਂਟ",
    highlightLinks: "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
    highlightTitles: "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
    colorTitle: "ਰੰਗ ਅਤੇ ਕੰਟਰਾਸਟ",
    monochrome: "ਮੋਨੋਕ੍ਰੋਮ",
    lowSaturation: "ਘੱਟ ਸੰਤ੍ਰਿਪਤਾ",
    highSaturation: "ਉੱਚ ਸੰਤ੍ਰਿਪਤਾ",
    highContrast: "ਉੱਚ ਕੰਟਰਾਸਟ",
    lightContrast: "ਲਾਈਟ ਕੰਟਰਾਸਟ",
    darkMode: "ਡਾਰਕ ਮੋਡ",
    aidsTitle: "ਵਿਜ਼ੂਅਲ ਅਤੇ ਨੇਵੀਗੇਸ਼ਨ ਸਹਾਇਤਾ",
    focusHighlight: "ਫੋਕਸ ਹਾਈਲਾਈਟ",
    readingGuide: "ਰੀਡਿੰਗ ਗਾਈਡ",
    readingMask: "ਰੀਡਿੰਗ ਮਾਸਕ",
    bigCursor: "ਵੱਡਾ ਕਰਸਰ",
    screenReader: "ਸਕ੍ਰੀਨ ਰੀਡਰ",
    pageStructure: "ਪੇਜ ਬਣਤਰ",
    additionalTitle: "ਵਾਧੂ ਕੰਟਰੋਲ",
    pauseGifs: "ਜਿਫਾਂ ਨੂੰ ਰੋਕੋ",
    hideImages: "ਚਿੱਤਰ ਲੁਕਾਓ",
    imageTooltips: "ਚਿੱਤਰ ਟੂਲਟਿਪਸ",
    statement: "ਪਹੁੰਚਯੋਗਤਾ ਬਿਆਨ",
    poweredBy: "ਸਿਏਨਾ ਸਮਰੱਥ",
    modalTitle: "ਪੇਜ ਬਣਤਰ ਸਹਾਇਕ",
    headingsTab: "ਸਿਰਲੇਖ",
    landmarksTab: "ਲੈਂਡਮਾਰਕ",
    linksTab: "ਲਿੰਕ",
    focusAction: "ਫੋਕਸ ਕਰੋ",
    noHeadings: "ਇਸ ਪੰਨੇ 'ਤੇ ਕੋਈ ਸਿਰਲੇਖ ਨਹੀਂ ਮਿਲਿਆ।",
    noLandmarks: "ਕੋਈ ਲੈਂਡਮਾਰਕ ਨਹੀਂ ਮਿਲਿਆ।",
    noLinks: "ਕੋਈ ਲਿੰਕ ਨਹੀਂ ਮਿਲਿਆ।",
    selectLang: "ਭਾਸ਼ਾ ਚੁਣੋ"
  },
  sd: {
    settingsTitle: "دسترس پذيريءَ جون سيٽنگون",
    resetSettings: "سيٽنگون ٻيهر سيٽ ڪريو",
    closePanel: "پينل بند ڪريو",
    profilesTitle: "دسترس پذيريءَ جا پروفائل",
    seizureSafe: "مرگهي کان محفوظ",
    seizureSafeDesc: "اينيميشنز کي روڪي ٿو ۽ سچوريشن گهٽائي ٿو.",
    adhdFriendly: "ADHD دوستاڻو",
    adhdFriendlyDesc: "فوڪس گائيڊ شامل ڪري ٿو، تصويرون لڪائي ٿو، جفس کي روڪي ٿو.",
    lowVision: "گهٽ نظر",
    lowVisionDesc: "تيز ڪنٽراسٽ، وڏو ڪرسر، وڏي ڪري سگهجندڙ تحرير.",
    cognitiveRead: "ذهني ۽ پڙهڻ",
    cognitiveReadDesc: "ڊسليڪسيا فونٽ، ठلڪ عنوان، وڏي وٿي.",
    textTitle: "تحرير ۽ پڙهڻ جي قابليت",
    adjustFontSize: "فونٽ سائيز تبديل ڪريو",
    boldText: "ठلڪ تحرير",
    lineHeight: "لائن جي اوچائي",
    letterSpacing: "اکرن جي وٿي",
    dyslexiaFont: "ڊسليڪسيا فونٽ",
    highlightLinks: "لنڪس نمايان ڪريو",
    highlightTitles: "عنوان نمايان ڪريو",
    colorTitle: "رنگ ۽ ڪنٽراسٽ",
    monochrome: "مونوڪروم",
    lowSaturation: "گهٽ سچوريشن",
    highSaturation: "تيز سچوريشن",
    highContrast: "تيز ڪنٽراسٽ",
    lightContrast: "هلڪو ڪنٽراسٽ",
    darkMode: "ڊارک موڊ",
    aidsTitle: "بصري ۽ نيويگيشن مدد",
    focusHighlight: "فوڪس نمايان",
    readingGuide: "ريڊنگ گائيڊ",
    readingMask: "ريڊنگ ماسڪ",
    bigCursor: "وڏو ڪرسر",
    screenReader: "اسڪرين ريڈير",
    pageStructure: "صفحي جي بناوٽ",
    additionalTitle: "اضافي ڪنٽرول",
    pauseGifs: "جفس کي روڪيو",
    hideImages: "تصويرون لڪايو",
    imageTooltips: "تصوير جا ٽولٽپس",
    statement: "دسترس پذيريءَ جو بيان",
    poweredBy: "سينا فعال",
    modalTitle: "صفحي جي بناوٽ جو مددگار",
    headingsTab: "عنوان",
    landmarksTab: "لينڊ مارڪس",
    linksTab: "لنڪس",
    focusAction: "فوڪس ڪريو",
    noHeadings: "هن صفحي تي ڪوبه عنوان نه مليو.",
    noLandmarks: "ڪوبه لينڊ مارڪ نه مليو.",
    noLinks: "ڪابه لنڪ نه ملي.",
    selectLang: "ٻولي چونڊيو"
  },
  ta: {
    settingsTitle: "அணுகல்தன்மை அமைப்புகள்",
    resetSettings: "அமைப்புகளை மீட்டமை",
    closePanel: "பேனலை மூடு",
    profilesTitle: "அணுகல்தன்மை சுயவிவரங்கள்",
    seizureSafe: "வலிப்பு பாதுகாப்பு",
    seizureSafeDesc: "அனிமேஷன்களை நிறுத்தி, செறிவைக் குறைக்கிறது.",
    adhdFriendly: "ADHD நட்பு",
    adhdFriendlyDesc: "கவனம் வழிகாட்டியைச் சேர்க்கிறது, படங்களை மறைக்கிறது, கிஃப்களை நிறுத்துகிறது.",
    lowVision: "குறைந்த பார்வை",
    lowVisionDesc: "அதிக மாறுபாடு, பெரிய கர்சர், அளவிடக்கூடிய உரை.",
    cognitiveRead: "அறிவாற்றல் மற்றும் வாசிப்பு",
    cognitiveReadDesc: "டிஸ்லெக்ஸியா எழுத்துரு, தடிமனான தலைப்புகள், பரந்த இடைவெளி.",
    textTitle: "உரை & வாசிப்புத்திறன்",
    adjustFontSize: "எழுத்துரு அளவை சரிசெய்",
    boldText: "தடிமனான உரை",
    lineHeight: "வரியின் உயரம்",
    letterSpacing: "எழுத்து இடைவெளி",
    dyslexiaFont: "டிஸ்லெக்ஸியா எழுத்துரு",
    highlightLinks: "இணைப்புகளை முன்னிலைப்படுத்து",
    highlightTitles: "தலைப்புகளை முன்னிலைப்படுத்து",
    colorTitle: "நிறம் மற்றும் மாறுபாடு",
    monochrome: "ஒரே வண்ணம்",
    lowSaturation: "குறைந்த செறிவு",
    highSaturation: "அதிக செறிவு",
    highContrast: "அதிக மாறுபாடு",
    lightContrast: "ஒளி மாறுபாடு",
    darkMode: "இருண்ட பயன்முறை",
    aidsTitle: "காட்சி மற்றும் வழிசெலுத்தல் உதவிகள்",
    focusHighlight: "கவனத்தை முன்னிலைப்படுத்து",
    readingGuide: "வாசிப்பு வழிகாட்டி",
    readingMask: "வாசிப்பு முகமூடி",
    bigCursor: "பெரிய கர்சர்",
    screenReader: "திரை வாசிப்பான்",
    pageStructure: "பக்க அமைப்பு",
    additionalTitle: "கூடுதல் கட்டுப்பாடுகள்",
    pauseGifs: "கிஃப்களை நிறுத்து",
    hideImages: "படங்களை மறை",
    imageTooltips: "பட உதவிக்குறிப்புகள்",
    statement: "அணுகல்தன்மை அறிக்கை",
    poweredBy: "சியென்னா இயக்கப்பட்டது",
    modalTitle: "பக்க அமைப்பு உதவியாளர்",
    headingsTab: "தலைப்புகள்",
    landmarksTab: "இடக்குறிகள்",
    linksTab: "இணைப்புகள்",
    focusAction: "கவனம் செலுத்து",
    noHeadings: "இப்பக்கத்தில் தலைப்புகள் எதுவும் இல்லை.",
    noLandmarks: "இடக்குறிகள் எதுவும் இல்லை.",
    noLinks: "இணைப்புகள் எதுவும் இல்லை.",
    selectLang: "மொழியைத் தேர்ந்தெடுக்கவும்"
  },
  te: {
    settingsTitle: "యాక్సెసిబిలిటీ సెట్టింగ్‌లు",
    resetSettings: "సెట్టింగ్‌లను రీసెట్ చేయండి",
    closePanel: "ప్యానెల్‌ను మూసివేయండి",
    profilesTitle: "యాక్సెసిబిలిటీ ప్రొఫైల్‌లు",
    seizureSafe: "ఫిట్స్ సేఫ్",
    seizureSafeDesc: "యానిమేషన్‌లను ఆపివేస్తుంది మరియు సంతృప్తతను తగ్గిస్తుంది.",
    adhdFriendly: "ADHD ఫ్రెండ్లీ",
    adhdFriendlyDesc: "ఫోకస్ గైడ్‌ను జోడిస్తుంది, చిత్రాలను దాచిపెడుతుంది, గిఫ్‌లను నిలిపివేస్తుంది.",
    lowVision: "తక్కువ దృష్టి",
    lowVisionDesc: "అధిక కాంట్రాస్ట్, పెద్ద కర్సర్, స్కేలబుల్ టెక్స్ట్.",
    cognitiveRead: "కాగ్నిటివ్ & రీడింగ్",
    cognitiveReadDesc: "డైస్లెక్సియా ఫాంట్, బోల్డ్ శీర్షికలు, విస్తృత అంతరం.",
    textTitle: "టెక్స్ట్ & రీడబిలిటీ",
    adjustFontSize: "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయి",
    boldText: "బోల్డ్ టెక్స్ట్",
    lineHeight: "లైన్ ఎత్తు",
    letterSpacing: "అక్షరాల అంతరం",
    dyslexiaFont: "డైస్లెక్సియా ఫాంట్",
    highlightLinks: "లింక్‌లను హైలైట్ చేయి",
    highlightTitles: "శీర్షికలను హైలైట్ చేయి",
    colorTitle: "రంగు & కాంట్రాస్ట్",
    monochrome: "మోనోక్రోమ్",
    lowSaturation: "తక్కువ సంతృప్తత",
    highSaturation: "అధిక సంతృప్తత",
    highContrast: "అధిక కాంట్రాస్ట్",
    lightContrast: "లైట్ కాంట్రాస్ట్",
    darkMode: "డార్క్ మోడ్",
    aidsTitle: "విజువల్ & నావిగేషన్ ఎయిడ్స్",
    focusHighlight: "ఫోకస్ హైలైట్",
    readingGuide: "రీడింగ్ గైడ్",
    readingMask: "రీడింగ్ మాస్క్",
    bigCursor: "పెద్ద కర్సర్",
    screenReader: "స్క్రీన్ రీడర్",
    pageStructure: "పేజీ నిర్మాణం",
    additionalTitle: "అదనపు నియంత్రణలు",
    pauseGifs: "గిఫ్‌లను నిలిపివేయి",
    hideImages: "చిత్రాలను దాచు",
    imageTooltips: "చిత్ర చిట్కాలు",
    statement: "యాక్సెసిబిలిటీ స్టేట్‌మెంట్",
    poweredBy: "సియెన్నా యాక్టివ్",
    modalTitle: "పేజీ నిర్మాణ సహాయకారి",
    headingsTab: "శీర్షికలు",
    landmarksTab: "ల్యాండ్‌మార్క్‌లు",
    linksTab: "లింక్‌లు",
    focusAction: "ఫోకస్ చేయి",
    noHeadings: "ఈ పేజీలో శీర్షికలేవీ కనుగొనబడలేదు.",
    noLandmarks: "ల్యాండ్‌మార్క్‌లేవీ కనుగొనబడలేదు.",
    noLinks: "లింక్‌లేవీ కనుగొనబడలేదు.",
    selectLang: "భాషను ఎంచుకోండి"
  },
  ur: {
    settingsTitle: "رسائی کی ترتیبات",
    resetSettings: "ترتیبات کو دوبارہ ترتیب دیں",
    closePanel: "پینل بند کریں",
    profilesTitle: "رسائی کے پروفائلز",
    seizureSafe: "مرگی سے محفوظ",
    seizureSafeDesc: "اینیمیشنز کو روکتا ہے اور رنگت کو کم کرتا ہے۔",
    adhdFriendly: "ADHD دوستانہ",
    adhdFriendlyDesc: "توجہ گائیڈ شامل کرتا ہے، تصاویر چھپاتا ہے، جفس روکتا ہے۔",
    lowVision: "کمزور بینائی",
    lowVisionDesc: "تیز برعکس رنگ، بڑا کرسر، تبدیل پذیر متن۔",
    cognitiveRead: "دماغی اور پڑھنا",
    cognitiveReadDesc: "ڈیسلیکسیا فونٹ، جلی سرخیاں، وسیع فاصلہ۔",
    textTitle: "متن اور پڑھنے کی صلاحیت",
    adjustFontSize: "فونٹ سائز ایڈجسٹ کریں",
    boldText: "جلی متن",
    lineHeight: "لائن کی اونچائی",
    letterSpacing: "حروف کا فاصلہ",
    dyslexiaFont: "ڈیسلیکسیا فونٹ",
    highlightLinks: "روابط نمایاں کریں",
    highlightTitles: "سرخیاں نمایاں کریں",
    colorTitle: "رنگ اور برعکس",
    monochrome: "یک رنگا",
    lowSaturation: "کم رنگت",
    highSaturation: "تیز رنگت",
    highContrast: "تیز برعکس",
    lightContrast: "ہلکا برعکس",
    darkMode: "ڈارک موڈ",
    aidsTitle: "بصరి اور نیویگیشن امداد",
    focusHighlight: "فوکس نمایاں کریں",
    readingGuide: "ریڈنگ گائڈ",
    readingMask: "ریڈنگ ماسک",
    bigCursor: "بڑا کرسر",
    screenReader: "اسکرین ریڈر",
    pageStructure: "صفحہ کی ساخت",
    additionalTitle: "اضافی کنٹرولز",
    pauseGifs: "جفس روکیں",
    hideImages: "تصاویر چھپائیں",
    imageTooltips: "تصویر کی تفصیلات",
    statement: "رسائی کا بیان",
    poweredBy: "سینا فعال",
    modalTitle: "صفحہ ساخت مددگار",
    headingsTab: "سرخیاں",
    landmarksTab: "نشانات",
    linksTab: "روابط",
    focusAction: "فوکس کریں",
    noHeadings: "اس صفحہ پر کوئی سرخی نہیں ملی۔",
    noLandmarks: "کوئی نشانات نہیں ملے۔",
    noLinks: "کوئی روابط نہیں ملے۔",
    selectLang: "زبان منتخب کریں"
  },
  es: {
    settingsTitle: "Ajustes de Accesibilidad",
    resetSettings: "Restablecer ajustes",
    closePanel: "Cerrar panel",
    profilesTitle: "Perfiles de Accesibilidad",
    seizureSafe: "Seguro para Convulsiones",
    seizureSafeDesc: "Detiene animaciones y reduce saturación.",
    adhdFriendly: "Amigable para TDAH",
    adhdFriendlyDesc: "Añade guía de lectura, oculta imágenes y gifs.",
    lowVision: "Discapacidad Visual",
    lowVisionDesc: "Alto contraste, cursor grande, texto escalable.",
    cognitiveRead: "Cognitivo y Lectura",
    cognitiveReadDesc: "Fuente para dislexia, títulos en negrita y espaciado.",
    textTitle: "Texto y Lectura",
    adjustFontSize: "Ajustar tamaño de letra",
    boldText: "Texto en Negrita",
    lineHeight: "Altura de Línea",
    letterSpacing: "Espaciado de Letras",
    dyslexiaFont: "Fuente Dislexia",
    highlightLinks: "Resaltar Enlaces",
    highlightTitles: "Resaltar Títulos",
    colorTitle: "Color y Contraste",
    monochrome: "Monocromo",
    lowSaturation: "Baja Saturación",
    highSaturation: "Alta Saturación",
    highContrast: "Alto Contraste",
    lightContrast: "Contraste Claro",
    darkMode: "Modo Oscuro",
    aidsTitle: "Ayudas Visuales y de Navegación",
    focusHighlight: "Resaltar Enfoque",
    readingGuide: "Guía de Lectura",
    readingMask: "Máscara de Lectura",
    bigCursor: "Cursor Grande",
    screenReader: "Lector de Pantalla",
    pageStructure: "Estructura de Página",
    additionalTitle: "Controles Adicionales",
    pauseGifs: "Pausar Gifs",
    hideImages: "Ocultar Imágenes",
    imageTooltips: "Descripciones de Imagen",
    statement: "Declaración de Accesibilidad",
    poweredBy: "Sienna Habilitado",

    // Modal
    modalTitle: "Asistente de Estructura de Página",
    headingsTab: "Cabeceras",
    landmarksTab: "Puntos de Referencia",
    linksTab: "Enlaces",
    focusAction: "Enfocar",
    noHeadings: "No se encontraron cabeceras en esta página.",
    noLandmarks: "No se encontraron puntos de referencia.",
    noLinks: "No se encontraron enlaces.",
    selectLang: "Seleccionar Idioma"
  },
  fr: {
    settingsTitle: "Paramètres d'accessibilité",
    resetSettings: "Réinitialiser",
    closePanel: "Fermer le panneau",
    profilesTitle: "Profils d'accessibilité",
    seizureSafe: "Sécurité épilepsie",
    seizureSafeDesc: "Arrête les animations et réduit la saturation.",
    adhdFriendly: "Adapté au TDAH",
    adhdFriendlyDesc: "Ajoute un guide de lecture, masque les images.",
    lowVision: "Basse vision",
    lowVisionDesc: "Contraste élevé, grand curseur, texte adaptable.",
    cognitiveRead: "Cognitif et Lecture",
    cognitiveReadDesc: "Police pour dyslexie, titres en gras, espacement.",
    textTitle: "Texte et Lisibilité",
    adjustFontSize: "Ajuster la taille de la police",
    boldText: "Texte en gras",
    lineHeight: "Hauteur de ligne",
    letterSpacing: "Espacement des lettres",
    dyslexiaFont: "Police dyslexie",
    highlightLinks: "Surligner les liens",
    highlightTitles: "Surligner les titres",
    colorTitle: "Couleur et Contraste",
    monochrome: "Monochrome",
    lowSaturation: "Faible saturation",
    highSaturation: "Saturation élevée",
    highContrast: "Contraste élevé",
    lightContrast: "Contraste clair",
    darkMode: "Mode sombre",
    aidsTitle: "Aides visuelles et navigation",
    focusHighlight: "Surligner la mise au point",
    readingGuide: "Guide de lecture",
    readingMask: "Masque de lecture",
    bigCursor: "Grand curseur",
    screenReader: "Lecteur d'écran",
    pageStructure: "Structure de page",
    additionalTitle: "Contrôles supplémentaires",
    pauseGifs: "Arrêter les GIFs",
    hideImages: "Masquer les images",
    imageTooltips: "Bulles d'aide d'image",
    statement: "Déclaration d'accessibilité",
    poweredBy: "Activé par Sienna",

    // Modal
    modalTitle: "Assistant de structure",
    headingsTab: "Titres",
    landmarksTab: "Points de repère",
    linksTab: "Liens",
    focusAction: "Focus",
    noHeadings: "Aucun titre trouvé.",
    noLandmarks: "Aucun point de repère trouvé.",
    noLinks: "Aucun lien trouvé.",
    selectLang: "Sélectionner la langue"
  },
  de: {
    settingsTitle: "Barrierefreiheit-Einstellungen",
    resetSettings: "Einstellungen zurücksetzen",
    closePanel: "Bedienfeld schließen",
    profilesTitle: "Barrierefreiheit-Profile",
    seizureSafe: "Anfallsicher",
    seizureSafeDesc: "Stoppt Animationen & verringert Sättigung.",
    adhdFriendly: "ADHS-freundlich",
    adhdFriendlyDesc: "Leseführung aktivieren, Bilder ausblenden.",
    lowVision: "Sehbehinderung",
    lowVisionDesc: "Hoher Kontrast, großer Mauszeiger, skalierbarer Text.",
    cognitiveRead: "Kognitives Lesen",
    cognitiveReadDesc: "Dyslexie-Schriftart, fettgedruckte Titel, Abstände.",
    textTitle: "Text & Lesbarkeit",
    adjustFontSize: "Schriftgröße anpassen",
    boldText: "Fetter Text",
    lineHeight: "Zeilenhöhe",
    letterSpacing: "Zeichenabstand",
    dyslexiaFont: "Dyslexie-Schriftart",
    highlightLinks: "Links hervorheben",
    highlightTitles: "Titel hervorheben",
    colorTitle: "Farbe & Kontrast",
    monochrome: "Monochrom",
    lowSaturation: "Geringe Sättigung",
    highSaturation: "Hohe Sättigung",
    highContrast: "Hoher Kontrast",
    lightContrast: "Heller Kontrast",
    darkMode: "Dunkelmodus",
    aidsTitle: "Seh- & Navigationshilfen",
    focusHighlight: "Fokus hervorheben",
    readingGuide: "Leselinie",
    readingMask: "Lesemaske",
    bigCursor: "Großer Cursor",
    screenReader: "Bildschirmleser",
    pageStructure: "Seitenstruktur",
    additionalTitle: "Zusätzliche Steuerelemente",
    pauseGifs: "GIFs anhalten",
    hideImages: "Bilder ausblenden",
    imageTooltips: "Bildbeschreibungen",
    statement: "Barrierefreiheitserklärung",
    poweredBy: "Sienna Aktiviert",

    // Modal
    modalTitle: "Seitenstruktur-Hilfe",
    headingsTab: "Überschriften",
    landmarksTab: "Orientierungspunkte",
    linksTab: "Links",
    focusAction: "Fokussieren",
    noHeadings: "Keine Überschriften gefunden.",
    noLandmarks: "Keine Orientierungspunkte gefunden.",
    noLinks: "Keine Links gefunden.",
    selectLang: "Sprache auswählen"
  }
};

// Initial state matching Sienna settings schema
const DEFAULT_STATES = {
  fontSize: 1.0,
  'font-weight': false,
  'line-height': false,
  'letter-spacing': false,
  'readable-font': false,
  'highlight-links': false,
  'highlight-title': false,
  'stop-animations': false,
  'hide-images': false,
  'image-tooltips': false,
  'readable-guide': false,
  'reading-mask': false,
  'big-cursor': false,
  'screen-reader': false,
  'page-structure': false,
  'super-focus': false,
  contrast: ''
};

export default function AccessibilityWidget() {
  const appContext = useContext(AppContext);
  const currentUser = appContext?.state?.currentUser;

  const [isOpen, setIsOpen] = useState(false);
  const [activeProfile, setActiveProfile] = useState(() => {
    try {
      const stored = localStorage.getItem('asw-user-settings');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.activeProfile) return parsed.activeProfile;
      }
    } catch (e) {}
    return '';
  });

  const [states, setStates] = useState(() => {
    try {
      const stored = localStorage.getItem('asw-user-settings');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.states) return { ...DEFAULT_STATES, ...parsed.states };
      }
    } catch (e) {}
    return DEFAULT_STATES;
  });

  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem('asw-user-settings');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.lang) return parsed.lang;
      }
    } catch (e) {}
    return 'en';
  });

  const [dynamicTranslations, setDynamicTranslations] = useState(null);
  // Mouse position for Reading Guide and Reading Mask
  const [mouseY, setMouseY] = useState(0);

  // Structure Helper Modal
  const [showStructureModal, setShowStructureModal] = useState(false);
  const [structureTab, setStructureTab] = useState('headings'); // headings, landmarks, links
  const [structureItems, setStructureItems] = useState({ headings: [], landmarks: [], links: [] });

  // Image Tooltip State
  const [tooltipText, setTooltipText] = useState('');
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  // Load configuration from local storage on mount
  useEffect(() => {
    const loadSettings = () => {
      try {
        const stored = localStorage.getItem('asw-user-settings');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed) {
            if (parsed.states) {
              setStates({ ...DEFAULT_STATES, ...parsed.states });
            }
            if (parsed.lang) {
              setLang(parsed.lang);
            }
            setActiveProfile(parsed.activeProfile || '');
          }
        }
      } catch (e) {
        console.warn('Failed to load accessibility settings from localStorage:', e);
      }
    };

    loadSettings();

    window.addEventListener('asw-update-settings', loadSettings);
    return () => {
      window.removeEventListener('asw-update-settings', loadSettings);
    };
  }, []);

  // Synchronize document language attribute and load translations dynamically when language changes
  useEffect(() => {
    // 1. Update HTML lang attribute so Sienna script detects it
    document.documentElement.setAttribute('lang', lang);

    // 2. Load translations
    if (TRANSLATIONS[lang]) {
      setDynamicTranslations(TRANSLATIONS[lang]);
      return;
    }

    let active = true;
    const fetchTranslation = async () => {
      const code = getLocaleFilename(lang);
      try {
        const response = await fetch(`https://cdn.jsdelivr.net/npm/sienna-accessibility@latest/dist/locales/${code}.json`);
        if (response.ok && active) {
          const data = await response.json();
          setDynamicTranslations(mapSiennaKeys(data));
        } else if (active) {
          setDynamicTranslations(TRANSLATIONS.en);
        }
      } catch (err) {
        console.warn(`Failed to fetch translation for ${lang}:`, err);
        if (active) {
          setDynamicTranslations(TRANSLATIONS.en);
        }
      }
    };

    fetchTranslation();
    return () => {
      active = false;
    };
  }, [lang]);



  // Write configuration to localStorage and update document class list whenever states change
  useEffect(() => {
    try {
      localStorage.setItem('asw-user-settings', JSON.stringify({
        lang,
        position: 'bottom-left',
        states,
        activeProfile
      }));
    } catch (e) {
      console.error(e);
    }

    // 1. Toggle standard CSS classes on HTML element
    const html = document.documentElement;
    html.classList.toggle('asw-font-weight', !!states['font-weight']);
    html.classList.toggle('asw-line-height', !!states['line-height']);
    html.classList.toggle('asw-letter-spacing', !!states['letter-spacing']);
    html.classList.toggle('asw-readable-font', !!states['readable-font']);
    html.classList.toggle('asw-highlight-links', !!states['highlight-links']);
    html.classList.toggle('asw-highlight-title', !!states['highlight-title']);
    html.classList.toggle('asw-stop-animations', !!states['stop-animations']);
    html.classList.toggle('asw-hide-images', !!states['hide-images']);
    html.classList.toggle('asw-big-cursor', !!states['big-cursor']);
    html.classList.toggle('asw-super-focus', !!states['super-focus']);

    // 2. Toggle contrast classes
    html.classList.toggle('asw-contrast-monochrome', states.contrast === 'monochrome');
    html.classList.toggle('asw-contrast-high-saturation', states.contrast === 'high-saturation');
    html.classList.toggle('asw-contrast-low-saturation', states.contrast === 'low-saturation');
    html.classList.toggle('asw-contrast-high-contrast', states.contrast === 'high-contrast');
    html.classList.toggle('asw-contrast-light-contrast', states.contrast === 'light-contrast');
    html.classList.toggle('asw-contrast-dark-contrast', states.contrast === 'dark-contrast');

    // 3. Apply font scaling
    applyFontScaling(states.fontSize);
  }, [states, activeProfile, lang]);

  const hasReadableGuide = !!states['readable-guide'];
  const hasReadingMask = !!states['reading-mask'];
  const hasImageTooltips = !!states['image-tooltips'];
  const hasScreenReader = !!states['screen-reader'];

  // Track mouse coordinates for reading guide & reading mask
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMouseY(e.clientY);
    };

    if (hasReadableGuide || hasReadingMask) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [hasReadableGuide, hasReadingMask]);

  // Image alt tooltips logic
  useEffect(() => {
    if (!hasImageTooltips) {
      setShowTooltip(false);
      return;
    }

    const handleMouseOver = (e) => {
      const target = e.target;
      if (target.tagName === 'IMG') {
        const text = target.alt || target.src.split('/').pop() || 'Image Description';
        setTooltipText(text);
        setTooltipPos({ x: e.clientX + 10, y: e.clientY + 15 });
        setShowTooltip(true);
      }
    };

    const handleMouseMove = (e) => {
      if (showTooltip) {
        setTooltipPos({ x: e.clientX + 10, y: e.clientY + 15 });
      }
    };

    const handleMouseOut = (e) => {
      if (e.target.tagName === 'IMG') {
        setShowTooltip(false);
      }
    };

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseout', handleMouseOut);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, [hasImageTooltips, showTooltip]);

  // Screen Reader logic
  useEffect(() => {
    if (!hasScreenReader) {
      if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
      }
      return;
    }

    const speakText = (text) => {
      if (!('speechSynthesis' in window) || !text) return;
      window.speechSynthesis.cancel(); // stop current speech
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 1.0;
      window.speechSynthesis.speak(utterance);
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (target && target.closest('.asw-sidebar') === null && target.closest('.asw-float-btn') === null) {
        // Read out elements with text content (buttons, links, labels, headings, paragraphs)
        const tags = ['A', 'BUTTON', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P', 'LABEL', 'SPAN', 'LI'];
        if (tags.includes(target.tagName) && target.innerText) {
          speakText(target.innerText);
        } else if (target.tagName === 'IMG') {
          speakText(target.alt || 'Image element');
        }
      }
    };

    const handleFocus = (e) => {
      const target = e.target;
      if (target && target.closest('.asw-sidebar') === null && target.closest('.asw-float-btn') === null) {
        if (target.innerText) {
          speakText(target.innerText);
        } else if (target.placeholder) {
          speakText(target.placeholder);
        }
      }
    };

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('focusin', handleFocus);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('focusin', handleFocus);
      if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
      }
    };
  }, [hasScreenReader]);

  // Font size multiplier
  const applyFontScaling = (factor) => {
    const selector = "h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,th,td,span,blockquote,.asw-text";
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      // Avoid scaling the widget elements themselves
      if (
        el.closest('.asw-sidebar') ||
        el.closest('.asw-float-btn') ||
        el.closest('.asw-structure-modal') ||
        el.closest('.asw-skip-link') ||
        el.closest('.asw-img-tooltip')
      ) {
        return;
      }

      let orgVal = el.dataset.aswOrgFontSize;
      if (!orgVal) {
        const computedStyle = window.getComputedStyle(el);
        orgVal = parseInt(computedStyle.fontSize) || 16;
        el.dataset.aswOrgFontSize = String(orgVal);
      }
      const base = Number(orgVal);
      el.style.fontSize = `${base * factor}px`;
    });
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const resetAllSettings = () => {
    setStates(DEFAULT_STATES);
    setActiveProfile('');

    // Clear all inline font sizes
    const elements = document.querySelectorAll("[data-asw-org-font-size]");
    elements.forEach(el => {
      el.style.fontSize = '';
    });
  };

  const handleStateToggle = (key) => {
    setStates(prev => {
      const next = { ...prev };

      // If setting a contrast filter, clear other ones
      if (['monochrome', 'low-saturation', 'high-saturation', 'high-contrast', 'light-contrast', 'dark-contrast'].includes(key)) {
        if (prev.contrast === key) {
          next.contrast = '';
        } else {
          next.contrast = key;
        }
      } else {
        next[key] = !prev[key];
      }

      // Clear active profile since user is customizing settings manually
      setActiveProfile('');
      return next;
    });
  };

  const handleFontSizeChange = (direction) => {
    setStates(prev => {
      let size = prev.fontSize;
      if (direction === 'plus') {
        size = Math.min(2.0, size + 0.1);
      } else {
        size = Math.max(0.7, size - 0.1);
      }
      return {
        ...prev,
        fontSize: Number(size.toFixed(2))
      };
    });
    setActiveProfile('');
  };

  const handleProfileSelect = (profileKey) => {
    if (activeProfile === profileKey) {
      resetAllSettings();
      return;
    }

    resetAllSettings();
    setActiveProfile(profileKey);

    switch (profileKey) {
      case 'seizure-safe':
        setStates(prev => ({
          ...DEFAULT_STATES,
          'stop-animations': true,
          contrast: 'low-saturation'
        }));
        break;
      case 'adhd-friendly':
        setStates(prev => ({
          ...DEFAULT_STATES,
          'readable-guide': true,
          'stop-animations': true,
          'hide-images': true
        }));
        break;
      case 'visually-impaired':
        setStates(prev => ({
          ...DEFAULT_STATES,
          contrast: 'high-contrast',
          fontSize: 1.2,
          'big-cursor': true,
          'readable-font': true
        }));
        break;
      case 'cognitive-learning':
        setStates(prev => ({
          ...DEFAULT_STATES,
          'readable-font': true,
          'highlight-title': true,
          'highlight-links': true,
          'letter-spacing': true,
          'line-height': true
        }));
        break;
      default:
        break;
    }
  };

  // Compile elements for Heading Structure modal
  const openStructureModal = () => {
    const headings = Array.from(document.querySelectorAll('h1, h2, h3, h4, h5, h6')).map(el => ({
      tag: el.tagName,
      text: el.innerText || el.textContent || 'Untitled Heading',
      element: el
    }));

    const landmarks = Array.from(document.querySelectorAll('header, nav, main, footer, aside, [role="navigation"], [role="main"], [role="contentinfo"]')).map(el => {
      let tag = el.tagName.toLowerCase();
      if (el.getAttribute('role')) tag += `[role="${el.getAttribute('role')}"]`;
      return {
        tag: tag.toUpperCase(),
        text: el.getAttribute('aria-label') || el.className || 'Landmark region',
        element: el
      };
    });

    const links = Array.from(document.querySelectorAll('a[href]'))
      .filter(el => {
        // Skip links inside our widget
        if (el.closest('.asw-sidebar') || el.closest('.asw-float-btn')) return false;
        return (el.innerText || el.textContent || '').trim().length > 0;
      })
      .slice(0, 80) // Limit to first 80 links for usability
      .map(el => ({
        tag: 'LINK',
        text: (el.innerText || el.textContent).trim(),
        element: el,
        href: el.getAttribute('href')
      }));

    setStructureItems({ headings, landmarks, links });
    setShowStructureModal(true);
  };

  const handleStructureItemClick = (element) => {
    setShowStructureModal(false);
    setIsOpen(false);

    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Try to focus the element
      const originalTabIndex = element.getAttribute('tabindex');
      if (originalTabIndex === null) {
        element.setAttribute('tabindex', '-1');
      }
      element.focus();
      if (originalTabIndex === null) {
        // clean up tabindex if we added it temporarily
        setTimeout(() => element.removeAttribute('tabindex'), 2000);
      }

      // Temporary blink focus animation
      const originalOutline = element.style.outline;
      const originalOutlineOffset = element.style.outlineOffset;
      const originalTransition = element.style.transition;

      element.style.transition = 'outline 0.2s ease';
      element.style.outline = '4px solid #0848ca';
      element.style.outlineOffset = '2px';

      setTimeout(() => {
        element.style.outline = originalOutline;
        element.style.outlineOffset = originalOutlineOffset;
        setTimeout(() => {
          element.style.transition = originalTransition;
        }, 200);
      }, 2000);
    }, 100);
  };

  // Get localized string helper
  const t = dynamicTranslations || TRANSLATIONS[lang] || TRANSLATIONS.en;

  const isLoginPage = window.location.pathname.includes('/login') || window.location.pathname.includes('/forgot') || window.location.pathname.includes('/reset');
  
  if (isLoginPage || (currentUser?.role && currentUser.role !== 'CLIENT')) return null;

  return (
    <div role="region" aria-label="Accessibility Tools">


      {/* Floating Accessibility Button */}
      <button
        className="asw-float-btn"
        onClick={toggleSidebar}
        aria-label="Open Accessibility Options Panel"
        aria-expanded={isOpen}
      >
        {Icons.accessibility}
      </button>


      <div inert={!isOpen ? 'true' : undefined} className={`asw-sidebar ${isOpen ? 'open' : ''}`} role="dialog" aria-labelledby="asw-title" aria-hidden={!isOpen}>
        <div className="asw-header">
          <h2 id="asw-title" className="asw-header-title">
            {Icons.accessibility}
            <span>{t.settingsTitle}</span>
          </h2>
          <div className="asw-header-actions">
            <button
              className="asw-header-btn"
              onClick={resetAllSettings}
              title={t.resetSettings}
              aria-label={t.resetSettings}
            >
              {Icons.reset}
            </button>
            <button
              className="asw-header-btn"
              onClick={toggleSidebar}
              title={t.closePanel}
              aria-label={t.closePanel}
            >
              {Icons.close}
            </button>
          </div>
        </div>

        <div className="asw-content">
          {/* Section: Language Selector Dropdown */}
          <div className="asw-lang-selector">
            {Icons.globe}
            <select
              value={lang}
              onChange={(e) => setLang(e.target.value)}
              aria-label="Select Language"
            >
              <option value="" disabled>Select Language</option>
              <option value="am">አማርኛ (Amharic)</option>
              <option value="ar">العربية (Arabic)</option>
              <option value="bg">български (Bulgarian)</option>
              <option value="bn">বাংলা (Bengali)</option>
              <option value="ca">Català (Catalan)</option>
              <option value="cs">čeština (Czech)</option>
              <option value="da">Danish (Denmark)</option>
              <option value="de">Deutsch (German)</option>
              <option value="el">Ελληνικά (Greek)</option>
              <option value="en">English (English)</option>
              <option value="es">Español (Spanish)</option>
              <option value="fa">فارسی (Persian)</option>
              <option value="fi">suomi (Finnish)</option>
              <option value="fil">Tagalog (Filipino)</option>
              <option value="fr">Français (French)</option>
              <option value="gu">ગુજરાતી (Gujarati)</option>
              <option value="he">עברית (Hebrew)</option>
              <option value="hi">हिन्दी (Hindi)</option>
              <option value="hr">Hrvatski (Croatian)</option>
              <option value="hu">Magyar (Hungarian)</option>
              <option value="id">Bahasa Indonesia (Indonesian)</option>
              <option value="it">Italiano (Italian)</option>
              <option value="ja">日本語 (Japanese)</option>
              <option value="ka">ქართული (Georgian)</option>
              <option value="kn">ಕನ್ನಡ (Kannada)</option>
              <option value="ko">한국어 (Korean)</option>
              <option value="ku">Kurdî (Kurdish)</option>
              <option value="lb">Lëtzebuergesch (Luxembourgish)</option>
              <option value="ml">മലയാളം (Malayalam)</option>
              <option value="mn">Монгол (Mongolian)</option>
              <option value="ms">Bahasa Malaysia (Malay)</option>
              <option value="my">မြန်મા (Burmese)</option>
              <option value="ne">नेपाली (Nepali)</option>
              <option value="nl">Nederlands (Dutch)</option>
              <option value="no">Norsk (Norwegian)</option>
              <option value="pa">ਪੰજાબી (Punjabi)</option>
              <option value="pl">Polski (Polish)</option>
              <option value="pt">Português (Portuguese)</option>
              <option value="ro">Română (Romanian)</option>
              <option value="ru">Русский (Russian)</option>
              <option value="sd">سنڌي (Sindhi)</option>
              <option value="sk">slovenčina (Slovak)</option>
              <option value="sl">Slovenščina (Slovene)</option>
              <option value="sr">Srpski (Serbian)</option>
              <option value="sr-cyr">Српски (Serbian Cyrillic)</option>
              <option value="sv">Svenska (Swedish)</option>
              <option value="sw">Kiswahili (Swahili)</option>
              <option value="ta">தமிழ் (Tamil)</option>
              <option value="te">తెలుగు (Telugu)</option>
              <option value="th">ไทย (Thai)</option>
              <option value="tr">Türkçe (Turkish)</option>
              <option value="ur">اردو (Urdu)</option>
              <option value="vi">Tiếng Việt (Vietnamese)</option>
              <option value="zh">简体中文 (Simplified Chinese)</option>
            </select>
          </div>

          {/* Section: Profiles */}
          <div className="asw-card" style={{ display: 'none' }}>
            <div className="asw-card-header">{t.profilesTitle}</div>
            <div className="asw-profiles-grid">
              <div
                className={`asw-profile-item ${activeProfile === 'seizure-safe' ? 'active' : ''}`}
                onClick={() => handleProfileSelect('seizure-safe')}
                role="button"
                aria-pressed={activeProfile === 'seizure-safe'}
              >
                <div className="asw-profile-header">
                  <div className="asw-profile-icon">{Icons.profileSeizure}</div>
                  <div className="asw-profile-toggle" />
                </div>
                <div className="asw-profile-title">{t.seizureSafe}</div>
                <div className="asw-profile-desc">{t.seizureSafeDesc}</div>
              </div>

              <div
                className={`asw-profile-item ${activeProfile === 'adhd-friendly' ? 'active' : ''}`}
                onClick={() => handleProfileSelect('adhd-friendly')}
                role="button"
                aria-pressed={activeProfile === 'adhd-friendly'}
              >
                <div className="asw-profile-header">
                  <div className="asw-profile-icon">{Icons.profileAdhd}</div>
                  <div className="asw-profile-toggle" />
                </div>
                <div className="asw-profile-title">{t.adhdFriendly}</div>
                <div className="asw-profile-desc">{t.adhdFriendlyDesc}</div>
              </div>

              <div
                className={`asw-profile-item ${activeProfile === 'visually-impaired' ? 'active' : ''}`}
                onClick={() => handleProfileSelect('visually-impaired')}
                role="button"
                aria-pressed={activeProfile === 'visually-impaired'}
              >
                <div className="asw-profile-header">
                  <div className="asw-profile-icon">{Icons.profileVision}</div>
                  <div className="asw-profile-toggle" />
                </div>
                <div className="asw-profile-title">{t.lowVision}</div>
                <div className="asw-profile-desc">{t.lowVisionDesc}</div>
              </div>

              <div
                className={`asw-profile-item ${activeProfile === 'cognitive-learning' ? 'active' : ''}`}
                onClick={() => handleProfileSelect('cognitive-learning')}
                role="button"
                aria-pressed={activeProfile === 'cognitive-learning'}
              >
                <div className="asw-profile-header">
                  <div className="asw-profile-icon">{Icons.profileCognitive}</div>
                  <div className="asw-profile-toggle" />
                </div>
                <div className="asw-profile-title">{t.cognitiveRead}</div>
                <div className="asw-profile-desc">{t.cognitiveReadDesc}</div>
              </div>
            </div>
          </div>

          {/* Section: Text & Readability */}
          <div className="asw-card">
            <div className="asw-card-header">{t.textTitle}</div>

            <div className="asw-font-adjuster">
              <div className="asw-font-label">
                {Icons.fontSize}
                <span>{t.adjustFontSize}</span>
              </div>
              <div className="asw-font-actions">
                <button
                  className="asw-font-btn"
                  onClick={() => handleFontSizeChange('minus')}
                  aria-label="Decrease Font Size"
                >
                  -
                </button>
                <span className="asw-font-value">{(states.fontSize * 100).toFixed(0)}%</span>
                <button
                  className="asw-font-btn"
                  onClick={() => handleFontSizeChange('plus')}
                  aria-label="Increase Font Size"
                >
                  +
                </button>
              </div>
            </div>

            <div className="asw-controls-grid">
              <button
                className={`asw-control-btn ${states['font-weight'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('font-weight')}
                aria-pressed={states['font-weight']}
              >
                {Icons.fontWeight}
                <span>{t.boldText}</span>
              </button>

              <button
                className={`asw-control-btn ${states['line-height'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('line-height')}
                aria-pressed={states['line-height']}
              >
                {Icons.lineHeight}
                <span>{t.lineHeight}</span>
              </button>

              <button
                className={`asw-control-btn ${states['letter-spacing'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('letter-spacing')}
                aria-pressed={states['letter-spacing']}
              >
                {Icons.letterSpacing}
                <span>{t.letterSpacing}</span>
              </button>

              <button
                className={`asw-control-btn ${states['readable-font'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('readable-font')}
                aria-pressed={states['readable-font']}
              >
                {Icons.dyslexia}
                <span>{t.dyslexiaFont}</span>
              </button>

              <button
                className={`asw-control-btn ${states['highlight-links'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('highlight-links')}
                aria-pressed={states['highlight-links']}
              >
                {Icons.highlightLinks}
                <span>{t.highlightLinks}</span>
              </button>

              <button
                className={`asw-control-btn ${states['highlight-title'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('highlight-title')}
                aria-pressed={states['highlight-title']}
              >
                {Icons.highlightTitles}
                <span>{t.highlightTitles}</span>
              </button>
            </div>
          </div>

          {/* Section: Color & Contrast */}
          <div className="asw-card">
            <div className="asw-card-header">{t.colorTitle}</div>
            <div className="asw-controls-grid">
              <button
                className={`asw-control-btn ${states.contrast === 'monochrome' ? 'active' : ''}`}
                onClick={() => handleStateToggle('monochrome')}
                aria-pressed={states.contrast === 'monochrome'}
              >
                {Icons.monochrome}
                <span>{t.monochrome}</span>
              </button>

              <button
                className={`asw-control-btn ${states.contrast === 'low-saturation' ? 'active' : ''}`}
                onClick={() => handleStateToggle('low-saturation')}
                aria-pressed={states.contrast === 'low-saturation'}
              >
                {Icons.lowSaturation}
                <span>{t.lowSaturation}</span>
              </button>

              <button
                className={`asw-control-btn ${states.contrast === 'high-saturation' ? 'active' : ''}`}
                onClick={() => handleStateToggle('high-saturation')}
                aria-pressed={states.contrast === 'high-saturation'}
              >
                {Icons.highSaturation}
                <span>{t.highSaturation}</span>
              </button>

              <button
                className={`asw-control-btn ${states.contrast === 'high-contrast' ? 'active' : ''}`}
                onClick={() => handleStateToggle('high-contrast')}
                aria-pressed={states.contrast === 'high-contrast'}
              >
                {Icons.highContrast}
                <span>{t.highContrast}</span>
              </button>

              <button
                className={`asw-control-btn ${states.contrast === 'light-contrast' ? 'active' : ''}`}
                onClick={() => handleStateToggle('light-contrast')}
                aria-pressed={states.contrast === 'light-contrast'}
              >
                {Icons.lightContrast}
                <span>{t.lightContrast}</span>
              </button>

              <button
                className={`asw-control-btn ${states.contrast === 'dark-contrast' ? 'active' : ''}`}
                onClick={() => handleStateToggle('dark-contrast')}
                aria-pressed={states.contrast === 'dark-contrast'}
              >
                {Icons.darkContrast}
                <span>{t.darkMode}</span>
              </button>
            </div>
          </div>

          {/* Section: Visual & Navigation Aids */}
          <div className="asw-card" style={{ display: 'none' }}>
            <div className="asw-card-header">{t.aidsTitle}</div>
            <div className="asw-controls-grid">
              <button
                className={`asw-control-btn ${states['super-focus'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('super-focus')}
                aria-pressed={states['super-focus']}
              >
                {Icons.superFocus}
                <span>{t.focusHighlight}</span>
              </button>

              <button
                className={`asw-control-btn ${states['readable-guide'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('readable-guide')}
                aria-pressed={states['readable-guide']}
              >
                {Icons.readingGuide}
                <span>{t.readingGuide}</span>
              </button>

              <button
                className={`asw-control-btn ${states['reading-mask'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('reading-mask')}
                aria-pressed={states['reading-mask']}
              >
                {Icons.readingMask}
                <span>{t.readingMask}</span>
              </button>

              <button
                className={`asw-control-btn ${states['big-cursor'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('big-cursor')}
                aria-pressed={states['big-cursor']}
              >
                {Icons.bigCursor}
                <span>{t.bigCursor}</span>
              </button>

              <button
                className={`asw-control-btn ${states['screen-reader'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('screen-reader')}
                aria-pressed={states['screen-reader']}
              >
                {Icons.screenReader}
                <span>{t.screenReader}</span>
              </button>

              <button
                className={`asw-control-btn`}
                onClick={openStructureModal}
                aria-label="Open page structure map"
              >
                {Icons.pageStructure}
                <span>{t.pageStructure}</span>
              </button>
            </div>
          </div>

          {/* Section: Additional Controls */}
          <div className="asw-card" style={{ display: 'none' }}>
            <div className="asw-card-header">{t.additionalTitle}</div>
            <div className="asw-controls-grid">
              <button
                className={`asw-control-btn ${states['stop-animations'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('stop-animations')}
                aria-pressed={states['stop-animations']}
              >
                {Icons.stopAnimations}
                <span>{t.pauseGifs}</span>
              </button>

              <button
                className={`asw-control-btn ${states['hide-images'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('hide-images')}
                aria-pressed={states['hide-images']}
              >
                {Icons.hideImages}
                <span>{t.hideImages}</span>
              </button>

              <button
                className={`asw-control-btn ${states['image-tooltips'] ? 'active' : ''}`}
                onClick={() => handleStateToggle('image-tooltips')}
                aria-pressed={states['image-tooltips']}
              >
                {Icons.imageTooltips}
                <span>{t.imageTooltips}</span>
              </button>
            </div>
          </div>

          {/* Bottom Reset Button */}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px', paddingBottom: '12px' }}>
            <button 
              onClick={resetAllSettings}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '10px 24px', 
                backgroundColor: '#0047b3', 
                color: '#ffffff', 
                border: 'none', 
                borderRadius: '6px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              <span style={{ width: '18px', height: '18px', display: 'flex' }}>{Icons.reset}</span>
              <span>{t.resetSettings}</span>
            </button>
          </div>
        </div>

        <div className="asw-footer">
          <a
            href="https://accessibility-widget.pages.dev/accessibility-statement/"
            target="_blank"
            rel="noopener noreferrer"
            className="asw-footer-link"
          >
            {t.statement}
          </a>
          <span className="asw-footer-powered">
            {t.poweredBy}
          </span>
        </div>
      </div>

      {/* Reading Guide Line Overlay */}
      {states['readable-guide'] && (
        <div
          className="asw-reading-line"
          style={{ display: 'block', top: `${mouseY}px` }}
        />
      )}

      {/* Reading Mask Overlay */}
      {states['reading-mask'] && (
        <>
          <div
            className="asw-mask-top"
            style={{ display: 'block', height: `${mouseY - 50}px` }}
          />
          <div
            className="asw-mask-bottom"
            style={{ display: 'block', top: `${mouseY + 50}px`, height: `calc(100vh - ${mouseY + 50}px)` }}
          />
        </>
      )}

      {/* Image Alt Tooltip */}
      {states['image-tooltips'] && showTooltip && (
        <div
          className="asw-img-tooltip"
          style={{ left: `${tooltipPos.x}px`, top: `${tooltipPos.y}px` }}
        >
          {tooltipText}
        </div>
      )}

      {/* Heading Structure Helper Modal */}
      {showStructureModal && (
        <div
          className="asw-structure-modal-overlay"
          onClick={() => setShowStructureModal(false)}
        >
          <div
            className="asw-structure-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="asw-structure-modal-title"
          >
            <div className="asw-structure-modal-header">
              <h3 id="asw-structure-modal-title">{t.modalTitle}</h3>
              <button
                className="asw-header-btn"
                onClick={() => setShowStructureModal(false)}
                aria-label="Close page structure helper"
              >
                {Icons.close}
              </button>
            </div>

            <div className="asw-structure-tab-bar">
              <button
                className={`asw-structure-tab ${structureTab === 'headings' ? 'active' : ''}`}
                onClick={() => setStructureTab('headings')}
              >
                {t.headingsTab} ({structureItems.headings.length})
              </button>
              <button
                className={`asw-structure-tab ${structureTab === 'landmarks' ? 'active' : ''}`}
                onClick={() => setStructureTab('landmarks')}
              >
                {t.landmarksTab} ({structureItems.landmarks.length})
              </button>
              <button
                className={`asw-structure-tab ${structureTab === 'links' ? 'active' : ''}`}
                onClick={() => setStructureTab('links')}
              >
                {t.linksTab} ({structureItems.links.length})
              </button>
            </div>

            <div className="asw-structure-modal-body">
              <div className="asw-structure-list">
                {structureTab === 'headings' && (
                  structureItems.headings.length === 0 ? (
                    <div className="asw-no-data">{t.noHeadings}</div>
                  ) : (
                    structureItems.headings.map((item, idx) => (
                      <div
                        key={idx}
                        className="asw-structure-list-item"
                        onClick={() => handleStructureItemClick(item.element)}
                      >
                        <span className="asw-structure-item-tag">{item.tag}</span>
                        <span className="asw-structure-item-text">{item.text}</span>
                        <span className="asw-structure-item-action">{t.focusAction} &rarr;</span>
                      </div>
                    ))
                  )
                )}

                {structureTab === 'landmarks' && (
                  structureItems.landmarks.length === 0 ? (
                    <div className="asw-no-data">{t.noLandmarks}</div>
                  ) : (
                    structureItems.landmarks.map((item, idx) => (
                      <div
                        key={idx}
                        className="asw-structure-list-item"
                        onClick={() => handleStructureItemClick(item.element)}
                      >
                        <span className="asw-structure-item-tag">{item.tag}</span>
                        <span className="asw-structure-item-text">{item.text}</span>
                        <span className="asw-structure-item-action">{t.focusAction} &rarr;</span>
                      </div>
                    ))
                  )
                )}

                {structureTab === 'links' && (
                  structureItems.links.length === 0 ? (
                    <div className="asw-no-data">{t.noLinks}</div>
                  ) : (
                    structureItems.links.map((item, idx) => (
                      <div
                        key={idx}
                        className="asw-structure-list-item"
                        onClick={() => handleStructureItemClick(item.element)}
                      >
                        <span className="asw-structure-item-tag">{item.tag}</span>
                        <span className="asw-structure-item-text" title={item.href}>
                          {item.text}
                        </span>
                        <span className="asw-structure-item-action">{t.focusAction} &rarr;</span>
                      </div>
                    ))
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
